import { useMemo } from 'react';
import {
  useFormState,
  Typography,
  TypographyVariants,
  TypographyWeights,
  TypographyColors,
} from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { FieldSection } from '@/components/common';
import { buildDeclarationSummarySections } from '../../constants/declarationSummaryFields';
import styles from './DeclarationSummaryStep.module.scss';

/**
 * Props:
 *   title     the card's heading
 *   columns   Array<{ id, heading, fields }> — one FieldSection each
 */
const SummarySection = ({ title, columns }) => (
  <div className={styles.card}>
    <div className={styles.cardHeader}>
      <Typography
        variant={TypographyVariants.bodySm}
        weight={TypographyWeights.semibold}
        color={TypographyColors.primary}
      >
        {title}
      </Typography>
    </div>
    <div className={styles.cardBody}>
      {columns.map((column) => (
        <FieldSection key={column.id} heading={column.heading} fields={column.fields} />
      ))}
    </div>
  </div>
);

// Step 4 — everything the three steps collected, read-only, before Save files it.
export const DeclarationSummaryStep = () => {
  const t = useTranslations();
  const { values } = useFormState();

  const sections = useMemo(() => buildDeclarationSummarySections(t, values), [t, values]);

  return (
    <div className={styles.summary}>
      {sections.map((section) => (
        <SummarySection key={section.id} title={section.title} columns={section.columns} />
      ))}
    </div>
  );
};
